'use client';

import { useEffect, useState } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react';
import {
  Bars3Icon,
  CalendarIcon,
  DocumentDuplicateIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  UserIcon,
  CalendarDaysIcon,
  BellIcon,
  ArrowPathRoundedSquareIcon,
  Cog6ToothIcon,
  WalletIcon,
  ChartBarIcon,
  DocumentArrowUpIcon,
  PowerIcon,
  ClipboardDocumentCheckIcon,
  DocumentCheckIcon,
  CalendarDateRangeIcon,
  DocumentTextIcon,
  DocumentPlusIcon,

  PencilIcon,
  CheckBadgeIcon,
  ChevronDoubleRightIcon,
  BookmarkIcon,
  CheckCircleIcon,
  ArrowLeftIcon,
  ChartBarSquareIcon,
  ClockIcon,
  SpeakerWaveIcon,
  DocumentChartBarIcon,
  LinkIcon,
  ChatBubbleBottomCenterTextIcon


} from '@heroicons/react/20/solid';
import { BookOpenIcon, ScaleIcon, UserGroupIcon } from '@heroicons/react/24/solid';
import { Link, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import WeatherData from '../manager/weatherdata';

import {ViewColumnsIcon, ArrowsRightLeftIcon} from '@heroicons/react/20/solid'


import { ChatBubbleBottomCenterIcon } from '@heroicons/react/16/solid';
import { useContext } from 'react';
import { AuthContext } from '../AuthContext';


import LoadingComponent from '../manager/loading';
import ProjectChat from '../manager/projectchat';

import { format } from 'date-fns';
import ReactFlow, {
    Controls,
    Background,
    applyNodeChanges,
    applyEdgeChanges,
  } from "reactflow";
  import "reactflow/dist/style.css";

  import { ArrowDownIcon, ArrowUpIcon,  } from '@heroicons/react/20/solid'
import { CursorArrowRaysIcon, EnvelopeOpenIcon } from '@heroicons/react/24/outline'
import { AcademicCapIcon } from '@heroicons/react/24/solid'
import  ProjectDailyTasks from '../manager/projectdailytasks';
import { useLocation } from 'react-router-dom';

import { ChevronDownIcon } from '@heroicons/react/24/solid'
import Kanban from '../manager/kanban';






const navigation = [
    { name: 'Dashboard', href: '/staffdash', icon: HomeIcon, current: true },
    { name: 'My Profile', href: '/myprofile', icon: UserIcon, current: false },
    { name: 'My Projects', href: '/staff-project', icon: ChartBarSquareIcon, current: false },
    { name: 'Chat', href: '/chatdashboard', icon: ChatBubbleBottomCenterIcon, current: false },
    { name: 'Training', href: '/training', icon: AcademicCapIcon, current: false },
    { name: 'Log Out', href: '/logout', icon: PowerIcon, current: false },
  ];


   
    




function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Admin() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
    const [openProjectModal, setOpenProjectModal] = useState(false);
    const [processes, setProcesses] = useState([]);
    const [formData, setFormData] = useState({
      name: "",
      description: "",
      startDate: "",
      endDate: "",
      process: [], // Store selected processes as an array
      objective: "",
    
    });
    const [openReport, setOpenReport] = useState(false);
    const [loading, setLoading] = useState(false);
const [directory, setDirectory] = useState({});
const [projectSteps, setProjectSteps] = useState([]);
const [projectId, setProjectId] = useState(null);
const [isFullscreen, setIsFullscreen] = useState(false);
const [openProjectSteps, setOpenProjectSteps] = useState(false);
const [projectName, setProjectName] = useState(null);
const [meetings, setMeetings] = useState([]);
const [deleteModal , setDeleteModal] = useState(false);
const [activeTab, setActiveTab] = useState('kanban'); // Default active tab





  

    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen);
      };
  
    // Fetch processes from the API
    const getProcess = async () => {
        
      try {
        const response = await fetch("https://api.insightos.co.uk/api/process", {
          method: "GET",
          headers: { }, credentials: 'include',
        });
        const data = await response.json();
  
        if (data.success) {
          setProcesses(data.data); // Update processes state with the fetched data
        } else {
          console.error("Failed to fetch processes:", data.message);
        }
      } catch (error) {
        console.error("Error fetching processes:", error);
      }
    };

    const fetchProjects = async () => {
        const token = localStorage.getItem("token");    

        try {
            const response = await fetch("https://api.insightos.co.uk/api/staffprojects", {
                method: "GET",

                headers: { }, credentials: 'include',
            });
            const data = await response.json();

            if (data.success) {

                console.log("Projects:", data.data);            
                
                const dir = data.data.reduce((acc, proc) => {
                    const letter = proc.Name[0].toUpperCase();
                    if (!acc[letter]) acc[letter] = [];
                    acc[letter].push(proc);
                    acc[letter].sort((a, b) => a.Name.localeCompare(b.Name));
                    return acc;
                  }, {});
                  setDirectory(dir);            } else {
                console.error("Failed to fetch projects:", data.message);
            }

        } catch (error) {

            console.error("Error fetching projects:", error);

        }

    };


    // i want to get project steps when the useLocation triggers the project id

    const location = useLocation();


    useEffect(() => {

        if (location.state) {

            // get the project id from the location state

            const projectId = location.state.projectId;

            // now we want to get the steps for this project

            handleGetSteps(projectId);

        }

    }, [location]);



   


const Navigate = useNavigate();




    useEffect(() => {
        fetchProjects();
    }, []);



  
    // Fetch processes when the component mounts or the modal opens
    useEffect(() => {
      if (openProjectModal) {
        getProcess(); // Fetch processes when the modal is open
      }
    }, [openProjectModal]);

    const handleSaveData = async () => {
        setLoading(true);
    
        try {
            // Create a new object to avoid mutating state directly
            const requestData = { ...formData, openReport };
    
            const response = await fetch("https://api.insightos.co.uk/api/projectsave", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include',

                body: JSON.stringify(requestData),
            });
    
            // Check if the response is OK before parsing JSON
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const data = await response.json();
    
            if (data.success) {
                console.log("Data saved successfully:", data);

                // fetch projects again to update the directory

setOpenProjectModal(false);
setOpenReport(false);                

                fetchProjects();
            } else {
                console.error("Server responded with an error:", data);
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleGetSteps = async (id, name) => {
      try {
        const response = await fetch(`https://api.insightos.co.uk/api/getprojectsteps/${id}`, {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });
        const data = await response.json();

        if (response.ok) {
          // Get current date and time
          const now = new Date();
          const currentDate = format(now, "yyyy-MM-dd");
          // Add kanban status to each task
          const tasksWithStatus = data.data.map(task => {
            // Skip assigning kanban status if the task is a Break task
            if (task.Task === "Break") {
              return { ...task, kanbanStatus: "Break" }; // Special status that won't appear in kanban
            }
            
            // Default status based on completion
            let kanbanStatus = "todo";
            
            // If task is completed
            if (task.Completed === 1) {
              kanbanStatus = "completed";
            } 
            // If task is today and not completed, mark as in-progress
            else {
              const taskDate = format(new Date(task.TaskDate), "yyyy-MM-dd");
              if (taskDate === currentDate) {
          kanbanStatus = "in-progress";
              }
            }
            
            return { ...task, kanbanStatus };
          }).sort((a, b) => {
            // Sort by date within each kanban status category
            const dateA = new Date(a.TaskDate);
            const dateB = new Date(b.TaskDate);
            
            // First sort by kanban status to keep the grouping
            if (a.kanbanStatus !== b.kanbanStatus) {
              return 0; // Keep original grouping order
            }
            
            // Then sort by date within each status group (earliest first)
            return dateA - dateB;
          });
          
          // Sort tasks by date and time
          const sortedData = tasksWithStatus.sort((a, b) => {
            const dateA = new Date(a.TaskDate + " " + a.StartTime);
            const dateB = new Date(b.TaskDate + " " + b.StartTime);
            return dateA - dateB;
          });

// remove Break tasks from the sortedData

          

          console.log("Project steps:", sortedData);
          setProjectSteps(sortedData);
          setOpenProjectSteps(true);
          setProjectId(id);
          setProjectName(name);

          const meetings = data.meetings;
          console.log("Meetings:", meetings);
          setMeetings(meetings);
        } else {
          console.error("Failed to fetch project steps:", data.message);
        }
      } catch (error) {
        console.error("Error fetching project steps:", error);
      }
    };

    useEffect(() => {
        // if projectSteps is not empty, then set a timeout on handleGetSteps to refresh the data every 5 minutes
        if (projectSteps.length > 0) {
            const interval = setInterval(() => {
                handleGetSteps(projectId);
                currentProgress();
            }, 60000); // 5 minutes
            return () => clearInterval(interval);
        }
    }, [projectSteps]);


    const [selectedNode, setSelectedNode] = useState(null); // To store the selected node's data

    const handleNodeClick = (_event, node) => {
      // Find the node data and set it to the selectedNode state
      const selectedStep = projectSteps.find(step => step.TaskID.toString() === node.id);
      setSelectedNode(selectedStep);
    };

    const nodeSpacingX = 140; // 🔽 Reduce horizontal spacing
    const nodeSpacingY = 400; // 🔽 Reduce vertical spacing

    // 🛠 Group steps by ProcessId (Each ProcessId gets its own row)
    const groupedSteps = projectSteps.reduce((acc, step) => {
      if (!acc[step.ProcessId]) acc[step.ProcessId] = [];
      acc[step.ProcessId].push(step);
      return acc;
    }, {});

    // Function to convert time string (hh:mm:ss) to x position
    const timeToPosition = (timeString) => {
      // Default to 7am if time is invalid
      if (!timeString) return 0;
      
      const [hours, minutes, seconds] = timeString.split(':').map(Number);
      
      // Calculate position relative to 7am (start) and 7pm (end)
      const startHour = 7; // 7am
      const endHour = 19;  // 7pm
      const totalHours = endHour - startHour;
      const timeInHours = hours + minutes/60 + (seconds || 0)/3600;
      
      // Normalize to our timeline (0 = 7am, 1200 = 7pm)
      // Ensure time is within our range
      const normalizedPosition = Math.max(0, Math.min(1, (timeInHours - startHour) / totalHours));
      return normalizedPosition * 1200; // Scale to 1200px width
    };

    // Generate hour markers for timeline
    const hourMarkers = Array.from({ length: 13 }, (_, i) => {
      const hour = i + 7; // Start from 7am
      return {
        id: `hour-${hour}`,
        data: { label: `${hour > 12 ? hour - 12 : hour}${hour >= 12 ? 'pm' : 'am'}` },
        position: { x: timeToPosition(`${hour}:00:00`), y: -40 },
        style: {
          width: 100,
          height: 20,
          fontSize: '10px',
          background: 'transparent',
          border: 'none',
          color: '#fff',
          textAlign: 'center',
        },
      };
    });

    // Create flow view nodes
    const flowNodes = Object.entries(groupedSteps).flatMap(([_processId, steps], rowIndex) =>
      steps.flatMap((step, colIndex) => {
        const isCompleted = step.Completed === 1;
        const backgroundColor = isCompleted ? "#00FF88" : "#FF3131"; // 🟢 Completed / 🔴 Not Completed
        const nodesList = [];

        // 🔷 Main Step Node with position indicator
        nodesList.push({
          id: step.TaskID?.toString(),
          data: { label: `${colIndex + 1}/${steps.length}: ${step.Role} - ${step.Name} - ${step.Task} (${step.Description}) ${step.StartTime} (${format(new Date(step.TaskDate), "dd/MM/yyyy")})` },
          position: { x: colIndex * nodeSpacingX, y: rowIndex * nodeSpacingY },
          style: {
            background: backgroundColor,
            color: "#fff",
            borderRadius: "10px",
            boxShadow: `0px 0px 8px ${backgroundColor}`,
            padding: "8px",
            fontSize: "12px",
            width: 120,
          },
        });

        // 🟡 Issue Nodes (Circles)
        (step.issues || []).forEach((issue, issueIndex) => {
          nodesList.push({
            id: `issue-${step.TaskID}-${issueIndex}`,
            data: { label: issue.Name || "Issue" },
            position: { // Add position property for issue nodes
              x: colIndex * nodeSpacingX + 0, 
              y: rowIndex * nodeSpacingY + 200 + issueIndex * 70
            },
            style: {
              background: "#FFD700",
              color: "#000",
              borderRadius: "50%", // 🟡 Circle shape
              width: 50,
              height: 50,
              fontSize: "10px",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0px 0px 6px #FFD700",
            },
          });

        // Add help nodes if issue has help info (may be multiple)
        if (issue.help && issue.help.length > 0) {
        issue.help.forEach((helpItem, helpIndex) => {
          nodesList.push({
          id: `help-${step.TaskID}-${issueIndex}-${helpIndex}`,
          data: { label: helpItem.StaffName },
          position: { 
            x: colIndex * nodeSpacingX + 0, 
            y: rowIndex * nodeSpacingY + 300 + issueIndex * 50 + helpIndex * 30 
          },
          style: {
            background: "#4A90E2",
            color: "#fff",
            borderRadius: "5px",
            padding: "5px",
            fontSize: "10px",
            width: 100,
            boxShadow: "0px 0px 6px #4A90E2",
          },
          });
        });
        }
      });

      return nodesList;
      })
    ).flat();

    // Group steps by date for timeline view
    const stepsByDate = projectSteps.reduce((acc, step) => {
      const dateKey = format(new Date(step.TaskDate), "yyyy-MM-dd");
      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push(step);
      return acc;
    }, {});

    // Sort steps within each date by StartTime
    Object.values(stepsByDate).forEach(steps => {
      steps.sort((a, b) => {
      return a.StartTime.localeCompare(b.StartTime);
      });
    });

    // Get sorted dates for timeline view
    const sortedDates = Object.keys(stepsByDate).sort();

    // Create timeline nodes with improved spacing and positioning
    const timelineNodes = [
      // Add horizontal line for timeline
      {
        id: 'timeline-base',
        data: { label: '' },
        position: { x: 0, y: 0 },
        style: {
          width: 1200,
          height: 2,
          background: '#fff',
          borderRadius: 0,
        },
      },
      // Add hour markers
      ...hourMarkers,
      // Add date headers and tasks
      ...sortedDates.flatMap((dateKey, dateIndex) => {
        const steps = stepsByDate[dateKey];
        const verticalOffset = dateIndex * 250; // Spacing between dates
        
        // Create date header node
        const dateNodes = [{
          id: `date-${dateKey}`,
          data: { label: format(new Date(dateKey), "EEE, dd MMM yyyy") },
          position: { x: -150, y: 30 + verticalOffset },
          style: {
            background: '#3b82f6',
            color: '#fff',
            borderRadius: '5px',
            padding: '4px',
            fontSize: '12px',
            width: 130,
            height: 30,
            textAlign: 'center',
            fontWeight: 'bold',
          },
        },
        // Add horizontal line for this date
        {
          id: `dateline-${dateKey}`,
          data: { label: '' },
          position: { x: 0, y: 45 + verticalOffset },
          style: {
            width: 1200,
            height: 1,
            background: '#3b82f6',
            opacity: 0.5,
          },
        }];
        
        // Group tasks by time slot to manage vertical positioning
        const timeSlots = {};
        steps.forEach(step => {
          const timeKey = step.StartTime.substring(0, 5); // HH:MM format
          if (!timeSlots[timeKey]) timeSlots[timeKey] = [];
          timeSlots[timeKey].push(step);
        });
        
        // Calculate hour width based on total timeline width
        const totalHours = 12; // 7am to 7pm
        const timelineWidth = 1200;
        const hourWidth = timelineWidth / totalHours;
        
        // Create task nodes for each time slot
        const taskNodes = [];
        
        Object.entries(timeSlots).forEach(([_timeKey, slotSteps]) => {
          slotSteps.forEach((step, stepIndex) => {
            const isCompleted = step.Completed === 1;
            // isBreak is a special task that we want to color in yellow 
            const backgroundColor = isCompleted ? "#00FF88" : "#FF3131";
            

            
            
            // Calculate exact x position based on time
            const xPos = timeToPosition(step.StartTime);
            
            // Calculate vertical position with enough space between tasks at same time
            const yOffset = stepIndex * 60;
            
            // Ensure node is centered at the time position
            taskNodes.push({
              id: step.TaskID?.toString(),
              data: { 
                label: `${step.Task} - ${step.Role} - ${step.Name}`,
                stepId: step.TaskID.toString() 
              },
              position: { 
                x: xPos,  // Position exactly at the time marker
                y: 60 + verticalOffset + yOffset
              },
              style: {
                background: backgroundColor,
                color: "#fff",
                borderRadius: "5px",
                top: 5,
                padding: "7px",
                fontSize: "7px",
                left: 45,
                width: hourWidth, // Match width to the hour width
                height: 50,
                textAlign: 'center',
                boxShadow: `0px 0px 8px ${backgroundColor}`,
              },
            });
          });
        });
        
        return [...dateNodes, ...taskNodes];
      })
    ];

    // Determine which nodes to use based on view mode
    const nodes = activeTab === 'flow' ? flowNodes : timelineNodes;

    // Only generate edges for flow view, not for timeline view
    const edges = activeTab === 'flow' ? Object.entries(groupedSteps).flatMap(([_processId, steps]) =>
      steps.flatMap((step, index, array) => {
        const mainStepId = step.TaskID?.toString();
        const edgesList = [];

        // 🔹 Edges between issues and their step
        (step.issues || []).forEach((issue, issueIndex) => {
          const issueId = `issue-${step.TaskID}-${issueIndex}`;
          
          // Add edge from main step to issue
          edgesList.push({
            id: `e-${mainStepId}-issue-${issueIndex}`,
            source: mainStepId,
            target: issueId,
            animated: true,
            style: { stroke: "#FFD700", strokeWidth: 1.5 },
          });
          
          // 🔷 Add edges from issue to each help item
          if (issue.help && issue.help.length > 0) {
            issue.help.forEach((helpItem, helpIndex) => {
              edgesList.push({
                id: `e-issue-${step.TaskID}-${issueIndex}-help-${helpIndex}`,
                source: issueId,
                target: `help-${step.TaskID}-${issueIndex}-${helpIndex}`,
                animated: true,
                style: { stroke: "#4A90E2", strokeWidth: 1.5, strokeDasharray: "5 5" },
              });
            });
          }
        });

        // 🔹 Connect steps within the same ProcessId (same row)
        if (index > 0) {
          edgesList.push({
            id: `e-${array[index - 1].TaskID}-${step.TaskID}`,
            source: array[index - 1].TaskID?.toString(),
            target: mainStepId,
            animated: true,
            style: { stroke: "#FFFFFF", strokeWidth: 1.5 },
          });
        }

        return edgesList;
      })
    ).flat() : []; // Empty array for timeline view - no connections

    // now we want to work out the stats for the project so if we are ahead or behind so we need to map through projectSteps to find out how many steps for each day and then how many are completed

    const currentProgress = () => {
      const today = new Date();

      // use date fns to match today with the .TaskDate 
      const stepsToday = projectSteps.filter(step => format(new Date(step.TaskDate), "dd/MM/yyyy") === format(today, "dd/MM/yyyy"));

      // okay now using today get the current time and use the StartTime which is hh:mm:ss to see how many tasks are up to this time

      // use date fns to get the current time

      const currentTime = format(today, "HH:mm:ss");

      // now we need to filter the stepsToday to see how many are up to the current time

      const stepsUpToNow = stepsToday.filter(step => step.StartTime <= currentTime);

      console.log("Steps up to now:", stepsUpToNow);

      console.log("Steps today:", stepsToday);

      // find out with steps up to now how many are completed

      const completedSteps = stepsUpToNow.filter(step => step.Completed === 1).length;

      return {
      totalSteps: stepsToday.length,
      completedSteps
      };
    };

    console.log(currentProgress());

    const overallProgress = () => {
      // Check if projectSteps is empty
      if (projectSteps.length === 0) {
      return {
        totalSteps: 0,
        completedSteps: 0
      };
      }

      const today = new Date();
      const currentDate = format(today, "dd/MM/yyyy");
      const currentTime = format(today, "HH:mm:ss");

      // Get all steps up to now (steps from previous days + today's steps up to current time)
      const stepsUpToNow = projectSteps.filter(step => {
      const stepDate = format(new Date(step.TaskDate), "dd/MM/yyyy");
      
      // Include if step date is before today
      if (stepDate < currentDate) return true;
      
      // Include if step date is today AND step time is up to current time
      if (stepDate === currentDate && step.StartTime <= currentTime) return true;
      
      return false;
      });

      // Count completed steps
      const completedSteps = stepsUpToNow.filter(step => step.Completed === 1).length;

      console.log("Steps up to now:", stepsUpToNow);
      console.log(`Overall progress: ${completedSteps}/${stepsUpToNow.length} steps completed`);

      return {
      totalSteps: stepsUpToNow.length,
      completedSteps
      };
    };

    console.log(overallProgress());

    const NodeDetailsModal = ({ nodeData, onClose }) => {
      if (!nodeData) return null;

      const bgColor = nodeData.Completed === 1 ? "bg-emerald-500" : "bg-red-500";

      return (
      <div className="flex items-center justify-center bg-black bg-opacity-50 w-full h-full z-50">
        <div className={`shadow-lg rounded-lg p-4 w-80 text-white ${bgColor}`}>
        {/* Header */}
        <div className="p-2 text-sm font-semibold text-center">Node Details</div>
        
        {/* Content */}
        <div className="p-2 space-y-2 text-xs">
          <p><strong>Role:</strong> {nodeData.Role}</p>
          <p><strong>Process:</strong> {nodeData.ProcessName}</p>
          <p><strong>Task:</strong> {nodeData.Task}</p>
          <p><strong>Name:</strong> {nodeData.Name}</p>
          <p><strong>Description:</strong> {nodeData.Description}</p>
          <p><strong>Start Time:</strong> {nodeData.StartTime}</p>
          <p><strong>Task Date:</strong> {format(new Date(nodeData.TaskDate), "dd/MM/yyyy")}</p>
          {nodeData !== null && (
          <p><strong>Outcome:</strong> {nodeData.Outcome}</p>
          )}
          
          {/* Issues Section */}
          {nodeData.issues?.length > 0 && (
          <div className="mt-2">
            <h3 className="font-semibold text-sm">Issues:</h3>
            {nodeData.issues.map((issue, index) => (
            <div key={index} className="p-2 rounded border border-white mt-1">
              <p><strong>Issues:</strong> {issue.length} issues</p>
            
              {issue.help?.length > 0 && (
              <div className="mt-1">
                <h4 className="font-semibold text-xs">Help:</h4>
                {issue.help.map((helpItem, helpIndex) => (
                <div key={helpIndex} className="p-1 rounded border border-white mt-1">
                  <p><strong>{helpItem.StaffName}</strong></p>
                </div>
                ))}
              </div>
              )}
            </div>
            ))}
          </div>
          )}
        </div>
        
        {/* Close Button */}
        <div className="p-2 flex justify-end">
          <button onClick={onClose} className="px-3 py-1 bg-white text-black rounded hover:bg-gray-300 text-xs">
          Close
          </button>
        </div>
        </div>
      </div>
      );
    };







  
    const stats = [
        {
            id: 1,
            name: "Total Project Steps",
            stat: projectSteps.length || "0",
            change: "100%",
            changeType: "increase",
            icon: DocumentDuplicateIcon,
        },
        {
            id: 2,
            name: "Completed Steps",
            stat: projectSteps.length > 0 
                ? `${Math.round((projectSteps.filter(step => step.Completed === 1).length / projectSteps.length) * 100)}%` 
                : "0%",
            change: `${projectSteps.filter(step => step.Completed === 1).length || "0"} steps`,
            changeType: "increase",
            icon: ClipboardDocumentCheckIcon,
        },
        {
            id: 3,
            name: "Pending Steps",
            stat: projectSteps.length > 0 
                ? `${Math.round((projectSteps.filter(step => step.Completed !== 1).length / projectSteps.length) * 100)}%` 
                : "0%",
            change: `${projectSteps.filter(step => step.Completed !== 1).length || "0"} steps`,
            changeType: "decrease",
            icon: DocumentCheckIcon,
        },
        {
            id: 4,
            name: "Current Daily Progress",
            stat: currentProgress().totalSteps > 0 
                ? `${Math.round((currentProgress().completedSteps / currentProgress().totalSteps) * 100)}%` 
                : "0%",
            change: (() => {
                const prog = currentProgress();
                const hoursDiff = prog.totalSteps - prog.completedSteps;
                return hoursDiff > 0 
                    ? `${hoursDiff} hour${hoursDiff !== 1 ? 's' : ''} behind` 
                    : hoursDiff < 0 
                        ? `${Math.abs(hoursDiff)} hour${Math.abs(hoursDiff) !== 1 ? 's' : ''} ahead` 
                        : "On target";
            })(),
            changeType: currentProgress().totalSteps > 0 && 
                (currentProgress().completedSteps / currentProgress().totalSteps) < 0.9 
                    ? "decrease" : "increase",
            icon: ArrowPathRoundedSquareIcon,
        },
        {
            id: 5,
            name: "Overall Progress",
            stat: overallProgress().totalSteps > 0 
                ? `${Math.round((overallProgress().completedSteps / overallProgress().totalSteps) * 100)}%` 
                : "0%",
            change: `${overallProgress().completedSteps}/${overallProgress().totalSteps} steps`,
            changeType: overallProgress().totalSteps > 0 && 
                (overallProgress().completedSteps / overallProgress().totalSteps) < 0.9 
                    ? "decrease" : "increase",
            icon: ArrowPathRoundedSquareIcon,
        },
    ];
    
    


    const tabs = [
      { name: 'Kanban', id: 'kanban', icon: ViewColumnsIcon, current: activeTab === 'kanban' },
      { name: 'Gantt', id: 'timeline', icon: ClockIcon, current: activeTab === 'timeline' },
      { name: 'Flow Chart', id: 'flow', icon: ArrowsRightLeftIcon, current: activeTab === 'flow' },
      { name: 'Meetings', id: 'meetings', icon: CalendarDaysIcon, current: activeTab === 'meetings' },
      {name: 'Chat', id: 'chat', icon: ChatBubbleBottomCenterTextIcon, current: activeTab === 'chat'}
    ];
    
    


return (
    <>
        <div>
        <div className="flex h-screen">
        {/* Sidebar (Fixed for Desktop) */}
        <div className="hidden lg:flex lg:flex-col lg:w-[80px] lg:fixed lg:inset-y-0 lg:left-0 lg:z-50 lg:bg-gradient-to-b from-indigo-900 via-sky-500 to-emerald-500 lg:pb-4 overflow-y-auto">
            <div className="flex h-16 items-center justify-center">
                <img alt="Logo" src="/1.png" className="h-10 w-auto rounded-full" />
            </div>
            <nav className="mt-8 flex flex-col items-center space-y-1">
                {navigation.map((item) => (
                    <div key={item.name} className="relative">
                        <Link
                            to={item.href}
                            className={`group flex items-center justify-center p-3 rounded-md ${
                                item.current ? "bg-white text-blue-700" : "text-white hover:bg-blue-700"
                            }`}
                        >
                            <item.icon className="h-6 w-6" />
                            <span className="absolute left-full ml-2 scale-0 bg-gray-700 px-2 py-1 text-xs text-white rounded-md transition-transform group-hover:scale-100">
                                {item.name}
                            </span>
                        </Link>
                    </div>
                ))}
            </nav>
        </div>

        {/* Sidebar (Mobile - Dialog) */}
        <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="lg:hidden">
            <DialogBackdrop className="fixed inset-0 bg-white opacity-75 transition-opacity" />
            <div className="fixed inset-0 flex">
                <DialogPanel className="w-full max-w-xs transform transition-all duration-300">
                    <div className="bg-gradient-to-b from-indigo-900 via-sky-500 to-emerald-500 p-6">
                        <div className="flex justify-between items-center">
                            <img alt="Logo" src="/1.png" className="h-8 rounded-full" />
                            <button onClick={() => setSidebarOpen(false)}>
                                <XMarkIcon className="h-6 w-6 text-white" />
                            </button>
                        </div>
                        <nav className="mt-8">
                            <ul className="space-y-2">
                                {navigation.map((item) => (
                                    <li key={item.name}>
                                        <Link
                                            to={item.href}
                                            className="flex items-center text-white hover:bg-blue-700 p-3 rounded-md"
                                        >
                                            <item.icon className="h-6 w-6" />
                                            <span className="ml-3">{item.name}</span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </DialogPanel>
            </div>
        </Dialog>

        {/* Main Content Wrapper */}
        <div className="flex flex-1 flex-col lg:ml-[80px] overflow-hidden">
            {/* Top Navbar (Mobile Only) */}
            <div className="sticky top-0 z-40 flex items-center bg-gradient-to-l from-indigo-900 via-sky-500 to-emerald-500 px-4 py-4 shadow-sm lg:hidden">
                <button onClick={() => setSidebarOpen(true)} className="text-white">
                    <Bars3Icon className="h-6 w-6" />
                </button>
                <div className="flex-1 text-white font-semibold">Dashboard</div>
                <img src="/2.png" className="h-10 w-10 rounded-full" />
            </div>

            {/* Content Layout */}
            <div className="flex h-full">
                {/* Sidebar for Extra Features */}
                {!openProjectSteps && (
                <div className="hidden sm:block w-1/3 lg:w-1/3 xl:w-1/3 border-r border-gray-200 p-6 overflow-y-auto">
                <WeatherData />
                <div className="mt-4">
                   
                <nav aria-label="Directory" className="h-full overflow-y-auto">
                {Object.keys(directory)
                    .sort()
                    .map((letter) => (
                        <div key={letter} className="mb-4">
                            <div className="sticky top-0 z-10 border-b bg-gray-50 px-3 py-1.5 text-sm font-semibold text-gray-900">
                                {letter}
                            </div>
        

{directory[letter].map((proc) => {
const bgColor = proc.Active === 1 ? "bg-emerald-500" : "bg-red-500";
const formattedStartDate = proc.StartDate ? format(new Date(proc.StartDate), "dd/MM/yyyy") : "N/A";
const formattedEndDate = proc.EndDate ? format(new Date(proc.EndDate), "dd/MM/yyyy") : "N/A";

return (
    <div
        key={proc.id}
        className={`w-full flex justify-between items-center mt-3 px-3 py-4 ${bgColor} rounded-lg shadow-md text-white cursor-pointer`}
        onClick={() => handleGetSteps(proc.id, proc.Name)}
    >
        <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold">{proc.Name}</p>
            <p className="mt-1 truncate text-xs">{proc.Description}</p>
            <p className="mt-1 text-xs">{proc.Author}</p>
            <p className="mt-1 text-xs">
                <span className="font-semibold">Start:</span> {formattedStartDate}
            </p>
            <p className="mt-1 text-xs">
                <span className="font-semibold">End:</span> {formattedEndDate}
            </p>
        </div>
        <ChevronDoubleRightIcon className="w-8 h-8" />
    </div>
);
})}

                        </div>
                    ))}
            </nav>
                    
                </div>
                </div>
                )}
                    

                {/* Main Content */}
                <div className={`${openProjectSteps ? "w-full" : "lg:w-3/4 xl:w-4/5 md:3/5"} overflow-y-auto p-6 min-w-0`}>
                


{openReport && (
<div className="flex flex-col space-y-6"> 
    <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-900">AI Report</h2>
            <button
                    type="button"
                    onClick={() => setOpenReport(false)}
                    className="text-sm font-semibold text-gray-900"
            >
                    Close
            </button>

    </div>

    <div className="bg-white p-6 rounded-md shadow-sm">
            <p className="mt-2 text-sm text-gray-700">{openReport}</p>

            <button onClick={handleSaveData}
            type="button"
            className="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
         Save Project 
            <CheckBadgeIcon aria-hidden="true" className="-mr-0.5 size-5" />
        </button>        
    </div>
</div>

)}
{openProjectSteps && (
                <>
             
                <div className="container mx-auto px-6">
                    {/* Back button */}
                    {deleteModal && (
                  <div className="bg-red-500 shadow sm:rounded-lg animate-pulse mb-10">
                  <div className="px-4 py-5 sm:p-6">
                    <div className="sm:flex sm:items-start sm:justify-between">
                      <div>
                        <h3 className="text-base font-semibold text-white">Are you sure?</h3>
                        <div className="mt-2 max-w-xl text-sm text-white">
                          <p>
                            All Project Data will be lost
                          </p>
                        </div>
                      </div>
                      <div className="mt-5 sm:ml-6 sm:mt-0 sm:flex sm:shrink-0 sm:items-center">
                        <button onClick = {handleDeleteProject}
                          type="button"
                          className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-red-500 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                          Delete
                        </button>
                        <button
                          type="button"
                          onClick={() => setDeleteModal(false)}
                          className="ml-3 inline-flex items-center rounded-md bg-emerald-500 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                )}
                    <div 
  className="flex items-center bg-gradient-to-r from-purple-500 to-blue-500 justify-between p-4 rounded-lg shadow-md bg-cover bg-center" 
   // Replace with your image URL
>
  {/* Back Button */}
  <button
    onClick={() => setOpenProjectSteps(false)}
    className="inline-flex items-center gap-x-2 rounded-md bg-white bg-opacity-70 px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-200"
  >
    <ArrowLeftIcon className="h-5 w-5" />
    Back to Projects
  </button>

 
</div>
<div className="mt-10">
                        <dl className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                            {stats.map((item) => (
                                <div
                                    key={item.id}
                                    className="relative overflow-hidden rounded-xl bg-white px-6 py-5 shadow-lg hover:shadow-xl transition duration-300"
                                >
                                    {/* Icon */}
                                    <dt className="flex items-center">
                                        <div className="rounded-md bg-indigo-500 p-3">
                                            <item.icon aria-hidden="true" className="size-6 text-white" />
                                        </div>
                                        <p className="ml-4 text-sm font-medium text-gray-500">{item.name}</p>
                                    </dt>
            
                                    {/* Statistic & Change Indicator */}
                                    <dd className="mt-3 flex items-center">
                                        <p className="text-3xl font-semibold text-gray-900">{item.stat}</p>
                                        <p
                                            className={classNames(
                                                item.changeType === "increase" ? "text-green-600" : "text-red-600",
                                                "ml-2 flex items-center text-sm font-semibold"
                                            )}
                                        >
                                            {item.changeType === "increase" ? (
                                                <ArrowUpIcon aria-hidden="true" className="size-5 text-green-500" />
                                            ) : (
                                                <ArrowDownIcon aria-hidden="true" className="size-5 text-red-500" />
                                            )}
                                            <span className="sr-only">
                                                {item.changeType === "increase" ? "Increased" : "Decreased"} by
                                            </span>
                                            {item.change}
                                        </p>
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    </div>
                    <div>
      <div className="grid grid-cols-1 sm:hidden">
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          defaultValue={tabs.find((tab) => tab.current).name}
          aria-label="Select a tab"
          className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
        <ChevronDownIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
        />
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
        <nav aria-label="Tabs" className="-mb-px flex space-x-8 mt-10 items-center justify-center p-3 bg-indigo-600 rounded-lg shadow-sm">
  {tabs.map((tab) => (
    <a
      key={tab.id}
      href="#"
      onClick={() => setActiveTab(tab.id)}
      aria-current={tab.current ? 'page' : undefined}
      className={classNames(
        tab.current ? 'border-yellow-500 text-white' : 'border-transparent text-white hover:border-white hover:text-yellow-500',
        'group inline-flex items-center border-b-2 px-1 py-4 text-sm font-medium',
      )}
    >
      <tab.icon
        aria-hidden="true"
        className={classNames(
          tab.current ? 'text-white animate-bounce' : 'text-white group-hover:text-yellow-500',
          '-ml-0.5 mr-2 size-5',
        )}
      />
      <span>{tab.name}</span>
    </a>
  ))}
</nav>

        </div>
      </div>
    </div>
                    
                    
    {(activeTab === 'flow' || activeTab === 'timeline') && (
                    <div className="bg-black p-6 shadow-md rounded-lg mt-10 relative">
                        <h3 className="text-lg font-semibold text-white">{projectName}</h3>
                        
            
                        {/* Fullscreen Toggle Button */}
                        <button
                            onClick={toggleFullscreen}
                            className="mt-4 bg-blue-600 hover:bg-blue-700 transition text-white font-medium px-5 py-2 rounded-lg"
                        >
                            {isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                        </button>
            
                        {/* Fullscreen Mode */}
                        <div
                            className={`transition-all duration-300 ease-in-out ${
                                isFullscreen ? "fixed inset-0 z-50" : "w-full h-80"
                            } bg-[#0A0F1E] rounded-xl shadow-lg overflow-hidden`}
                        >
                            {/* Close Fullscreen Button */}
                            {isFullscreen && (
                                <button
                                    onClick={toggleFullscreen}
                                    className="absolute top-5 right-5 bg-red-500 hover:bg-red-600 transition text-white px-4 py-2 rounded-lg z-10"
                                >
                                    Close Fullscreen
                                </button>
                                
                            )}
            
                            {/* ReactFlow Component */}
                            <ReactFlow
                                nodes={nodes}
                                edges={edges}
                                fitView
                                style={{ width: "100%", height: "100%" }}
                                onNodeClick={handleNodeClick}
                            >
                                <Controls />
                                <Background color="#444" gap={16} />
                            </ReactFlow>
            
                            {/* Node Details Modal */}
                            {selectedNode && (
  <div className="absolute bottom-0 left-0 w-full p-4 bg-gray-800 bg-opacity-90 rounded-t-xl">
    <NodeDetailsModal nodeData={selectedNode} onClose={() => setSelectedNode(null)} />
  </div>
)}

                        </div>
                    </div>
                    )}
                   

                    {/* Kanban Task Table */}
                  {activeTab === 'kanban' && (
<div className="mt-10">
  <Kanban projectSteps={projectSteps} />
</div>
)}

{activeTab === 'meetings' && (
                    <div className="mt-10">
                        {meetings.length > 0 && (
                            <div className="bg-white p-6 rounded-lg shadow-md">
                              <div className='flex items-center justify-between'>
                                <h3 className="text-lg font-semibold text-gray-900">Meetings</h3>
                                <button onClick={() => Navigate('/createmeeting')}  className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        <CalendarDaysIcon aria-hidden="true" className="-ml-0.5 size-5" />

                                  Schedule Meeting</button>
                              </div>
                                <ul className="mt-4 space-y-4">
                                {meetings.map((meeting) => {
  let meetingBackgroundColor = "bg-green-100"; // Default color
  let statusText = "Not Started";
  let showCancelButton = true;

  if (meeting.Start === 1 && meeting.Finished === 1) {
    meetingBackgroundColor = "bg-purple-100"; // Purple background for completed meeting
    statusText = "Meeting Completed";
    showCancelButton = false; // Hide Cancel button
  } else if (meeting.Start === 1 && meeting.Finished === 0) {
    meetingBackgroundColor = "bg-green-100 animate-pulse"; // Green background for in-progress meeting
    statusText = "In Progress";
  }

  return (
    <li 
      key={meeting.id} 
      className={`flex items-center justify-between p-4 rounded-lg shadow-md transition-all ${meetingBackgroundColor}`}
    >
      <div>
        <h4 className="text-base font-semibold text-gray-900">{meeting.Name}</h4>
        <p className="mt-1 text-sm text-gray-600">{meeting.Notes}</p>
        
        {/* Status Display */}
        <p className="mt-2 text-sm font-semibold text-gray-800">{statusText}</p>

        {/* Button to open Meeting Notes (Only shown if Notes exist) */}
        {meeting.MeetingNotes && (
          <button 
            onClick={() => alert(meeting.MeetingNotes)} 
            className="mt-2 text-sm text-indigo-600 underline"
          >
            View Notes
          </button>
        )}

        {/* Cancel Button (Only shown if meeting is not completed) */}
        {showCancelButton && (

<button  onClick={() => {
  const message = meeting
Navigate('/meeting', { state: { meeting: message } });
}}
className="inline-flex items-center gap-x-1.5 rounded-md mt-5 bg-emerald-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
>
  <CheckCircleIcon aria-hidden="true" className="-ml-0.5 size-5" />

            Start Meeting
          </button>
        )}
      </div>
      
      <div className="flex items-center gap-x-4">
        <p className="text-sm text-gray-600">{format(new Date(meeting.Date), "dd/MM/yyyy")}</p>
        <p className="text-sm text-gray-600">{meeting.Time}</p>
      </div>
    </li>
  );
})}

                                </ul>
                            </div>
                        )}
                    </div>
                )}
            {activeTab === 'chat' && (
                                <div className="mt-10">
                                    <ProjectChat projectId={projectId} />
                                </div>
                            )}
                    {/* 🌐 Process Flow Visualization */}
                
            
                    {/* Project Daily Tasks */}
                    <div className="w-full mt-10">
                      
                        <ProjectDailyTasks ProjectId={projectId} ProjectName = {projectName} />
                    </div>
                </div>
            </>
            )}          
                 

                    




                

                    {/* Tabs for Larger Screens */}
             
                    {/* Content Rendering */}
                 
                 </div>
                 </div>
                 </div>
                 </div>
    </div>

    </>
);
}
